import React from 'react';
import { Icon } from '../../../components/common/IconLibrary';
import './ErrorPage.scss';

const ErrorPage: React.FC = () => {
  return (
    <div className="error-page-container">
      <div className="error-card">
        <div className="centered-icon">
          <Icon iconName="cancel" iconColor="orange" size={64} />  {/* Ícono de cancel */}
        </div>
        <h1>Ups, algo salió mal</h1>
        <p>porfavor intenta de nuevo más tarde.</p>
      </div>
    </div>
  );
};

export default ErrorPage;
